import { render, staticRenderFns } from "./DropboxSaveModal.vue?vue&type=template&id=72bbd66a&"
import script from "./DropboxSaveModal.vue?vue&type=script&lang=js&"
export * from "./DropboxSaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DropboxSaveModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/DropboxSaveModal.vue
// module id = 2345
// module chunks = 1